export const TestIds = {
  Carousel: 'carousel',
  GraspLogo: 'graspLogo',
};
